import { render, staticRenderFns } from "./ShiftAddForm.vue?vue&type=template&id=4aea30b0"
import script from "./ShiftAddForm.vue?vue&type=script&lang=js"
export * from "./ShiftAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports